import { render, staticRenderFns } from "./AgendamentoModal.vue?vue&type=template&id=649eef9e"
import script from "./AgendamentoModal.vue?vue&type=script&lang=js"
export * from "./AgendamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports